import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
import MapLink from "../Buttons/MapLink";
// Assets
import LocalizacaoMapa from "../../assets/img/map/localizacao-mapa.png";


export default function Location() {
  return (
    <Wrapper id="location">
      <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <MapLink>
                    <MapImage className="radius8" src={LocalizacaoMapa} alt="Mapa" />
                  </MapLink>
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font14 semiBold">Desde 1986</h4>
              <h2 className="font30 semiBold">No centro de Florianópolis</h2>
              <p className="font13">
                Atrás do Camelódromo - Rua Francisco Tolentino, 310 - Centro, Florianópolis - SC, 88010-200
              </p>
              <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                <div style={{ width: "190px" }}>
                  <MapLink>
                    <FullButton title="Conheça nossos serviços" />
                  </MapLink>
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  margin: 240px 0 200px;

  @media (max-width: 860px) {
    margin: 125px 0 0;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 100%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 860px) {
    padding: 0;
  }
`;
const MapImage = styled.img`
  max-width: 541px;
  max-height: 786px;
  transition: .5s;
  :hover {
    transform: scale(1.03);
    transition: .5s;
  }

  @media (max-width: 760px) {
    transition: unset;
    pointer-events: none;
  }
`
